import { useState, useEffect } from 'react';
import type { Unsubscribe } from 'firebase/firestore';

interface UseFirestoreSubscriptionResult<T> {
    data: T | null;
    isLoading: boolean;
    error: Error | null;
}

export function useFirestoreSubscription<T>(
    subscribeFn: (callback: (data: T) => void) => Unsubscribe,
    deps: any[] = []
): UseFirestoreSubscriptionResult<T> {
    const [data, setData] = useState<T | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        let unsubscribe: Unsubscribe | undefined;

        try {
            unsubscribe = subscribeFn((newData) => {
                setData(newData);
                setIsLoading(false);
            });
        } catch (err: any) {
            setError(err);
            setIsLoading(false);
        }

        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return { data, isLoading, error };
}
